<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="Dedication">
<p class="ded"><span class="right_1" epub:type="pagebreak" id="page_282" title="282"><i>With love and appreciation for Zac Weikal</i></span></p>
<p class="ded1"><i>and the members of my Bakery Bunch</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310354369_Dedication_P4.vue?07308666